/**
 * Brimit brand colors - single source of truth for the frontend.
 * Backend equivalent: TimewritingNew.Shared.Constants.BrandConstants
 * SCSS equivalent: src/styles/_branding.scss
 */
export const BRAND_COLORS = {
  NAVY: '#172239',
  TEAL: '#3BBCA5',
  GREEN: '#6AC17E',
  DARK_GREEN: '#215D36',
  LIGHT_NAVY: '#2A3A5C',
} as const;

export const BRAND = {
  COMPANY_NAME: 'Brimit',
  PRODUCT_NAME: 'Brimit Timewriting',
} as const;
